<div class="entry-content">

  <p></p>



  <p>Este documento, denominado Política de Privacidade, possui finalidade de
    estabelecer as regras sobre o uso, armazenamento e tratamento dos dados e
    informações coletadas dos USUÁRIOS na PLATAFORMA RAPPI.</p>



  <p><a><strong>Responsáveis pelas Informações
        dos USUÁRIOS:</strong></a>&nbsp;<strong>RAPPI BRASIL
      INTERMEDIACAO DE NEGOCIOS LTDA</strong>., registrada sob o CNPJ 26.900.161/0001-25 e
    suas filiadas (“RAPPI”).</p>



  <p><strong>1.Definições importantes:</strong></p>



  <p><a><strong>ARRANJO DE PAGAMENTO VISA</strong></a>: é o arranjo de
    pagamento instituído pela Visa, empresa responsável pela marca e pelos sistemas
    físicos e digitais que permitem a emissão do Cartão e utilização em diferentes
    estabelecimentos credenciados, de acordo com a Lei nº 12.865/2013, e com o <em>Regulamento dos Arranjos de Pagamento
      da
      Visa do Brasil</em>, disponível no site da Visa, realizados através de RappiPay
    cartão.</p>



  <p><strong>BANCO DE DADOS:</strong>&nbsp;Conjunto estruturado de dados pessoais ou anônimizados, localizado
    em um ou em vários locais, em suporte eletrônico ou físico;</p>



  <p><strong>CARTÃO:</strong> é um cartão
    físico e/ou virtual que, a critério da RAPPI, pode ser oferecido aos
    Consumidores para usufruírem de serviços financeiros.</p>



  <p><strong>CONSENTIMENTO:</strong>&nbsp;É a manifestação livre, informada e inequívoca pela qual o USUÁRIO
    concorda com a utilização dos seus dados pessoais ou anônimizados.</p>



  <p><strong>CONSUMIDORES</strong>: São uma categoria específica de Usuários, em que são as pessoas naturais que
    se cadastraram na Plataforma e a utilizam para solicitar a realização de
    Encargos, através da PLATAFORMA.</p>



  <p><a><strong>CONTA</strong></a>: Uma vez realizado e aprovado o cadastro do Consumidor,
    será criada uma conta de pagamento na estrutura da RAPPI para viabilizar a
    execução de transações de pagamento mediante gestão dos valores aportados pelo
    Consumidor.
  </p>



  <p><strong>CONTEÚDO</strong>: Qualquer informação, dados, comunicações, software, fotos, vídeos,
    gráficos, música, sons e outros materiais e serviços que podem ser visualizados
    pelos USUÁRIOS na PLATAFORMA. Isso inclui mensagens, conversas, bate-papo e
    outros conteúdos originais.</p>



  <p><strong>COOKIES:</strong>&nbsp;Arquivos enviados pelo servidor da PLATAFORMA para o computador do
    USUÁRIO, com a finalidade de identificar o seu dispositivo e obter dados de
    acesso, como páginas navegadas ou links clicados, permitindo, desta forma,
    personalizar a utilização da PLATAFORMA, de acordo com o seu perfil. Também
    podem ser utilizados para garantir uma maior segurança dos USUÁRIOS da
    PLATAFORMA. <em>Para mais informações sobre como Cookies e tecnologias similares são
      utilizadas pela Rappi, por favor consulte a nossa </em><a
      href="https://legal.rappi.com/brazil/politica-de-cookies-brasil/"><em>Política de Cookies</em></a><em>.</em></p>



  <p><strong>DADOS PESSOAIS</strong>: todos os dados relacionados à pessoa natural (identificada ou
    identificável), não-públicos, relativos à identidade e à vida privada de seu
    USUÁRIO.</p>



  <p><strong>DADOS PESSOAIS ANÔNIMIZADOS ou ANÔNIMIZADOS</strong>: dados relativos a um USUÁRIO
    que não possa ser identificado.</p>



  <p><strong>ENCARGOS:</strong>&nbsp;são todos os tipos de solicitação que podem ser feitas por Consumidores
    e realizadas por Mandatários por meio da Plataforma, incluindo a aquisição de
    produtos e a entrega de encomendas. Para mais detalhes sobre como funcionam os
    Encargos, por favor consulte os <a
      href="https://legal.rappi.com/brazil/termos-e-condicoes-de-uso-da-plataforma-rappi/?_ga=2.115868864.714873495.1570199727-851551344.1569267089&amp;_gac=1.61606238.1570199727.CjwKCAjw29vsBRAuEiwA9s-0B5SnYuBEp3RH0BdqwnuBbqvAEuxPg5e7WOUFl5bxO6SQgt-zoWNEAxoCs1YQAvD_BwE">Termos
      de Uso da Plataforma</a>.</p>



  <p><strong>ESTABELECIMENTOS PARCEIROS:</strong>&nbsp;são os estabelecimentos comerciais que mantêm relação de parceria
    com a Rappi, a partir dos quais podem ser solicitados pedidos e Encargos para
    realização pelos Mandatários.</p>



  <p><strong>IP (Internet Protocol):</strong>&nbsp;É um conjunto de números que identifica o computador do USUÁRIO na
    Internet.</p>



  <p><strong>JANELAS (Pop-Ups):</strong>&nbsp;Janela ou aviso da internet que emerge automaticamente em qualquer
    momento quando a PLATAFORMA é utilizada, inclusive na formalização dos Termos e
    Condições do Uso da Plataforma e na Política de Privacidade.</p>



  <p><strong>LOGS</strong>: registros de atividades do USUÁRIO efetuadas na PLATAFORMA.</p>



  <p><a><strong>RAPPI</strong></a>: é a empresa proprietária e possuidora de todos os direitos autorais
    referente a Plataforma de Internet denominada RAPPI.</p>



  <p><strong>PARCEIRA DO
      ARRANJO DO ARRANJO </strong>: é a empresa
    responsável pela emissão do Cartão, sob o Arranjo de Pagamento Visa, que possui
    uma conta de pagamento atrelada a ele, com saldo zerado, que será entregue pela
    RAPPI.</p>



  <p><strong>MANDATÁRIOS:</strong> compõe uma categoria específica de Usuários, sendo as pessoas naturais parceiras da
    Rappi que se cadastraram na Plataforma
    e a utilizam para realizar Encargos a pedido de Consumidores.</p>



  <p><strong>MENSAGENS DE DADOS:</strong>&nbsp;A informação gerada, enviada, recebida, armazenada ou comunicada
    por meios eletrônicos, óticos ou similares. Exemplificando: os formulários de
    cadastramento, o Intercâmbio Eletrônico de Dados (EDI – Electronic Data
    Interchange), Internet, o correio eletrônico, chats entre outros meios de
    comunicação</p>



  <p><a><strong>PLATAFORMA RAPPI:</strong></a>&nbsp;aplicativo web e móvel administrado e com os direitos exclusivos
    de utilização no Brasil pela RAPPI, através do qual, em conjunto com a PARCEIRA
    DO ARRANJO: i) são exibidos diferentes produtos de consumo de forma
    publicitária (dos Prestadores de Serviço) para que possam servir de referência
    ao Consumidor; ii) facilita a aproximação entre os Consumidores e os
    Prestadores de Serviço; iii) serve como meio de envio de comunicações entre o
    Consumidor e a RAPPI; <a>iv) se aplicável, oferta Cartão e Conta ao Consumidor,
      por meio dos quais este pode movimentar recursos financeiros e realizar
      transações de pagamento; </a>e v)
    pode receber os pagamentos das compras diretamente do consumidor (por conta e
    ordem de terceiros), com repasse do dinheiro ao Prestador de Serviço. &nbsp;A
    RAPPI não realiza a compra de produtos por conta própria, não armazena produtos
    e tampouco é vendedora de produtos. É uma plataforma de tecnologia somente para
    intermediação da Venda, cobrando pelos serviços realizados<strong>.&nbsp;</strong>Também
    denominada neste Instrumento como&nbsp;<strong>“PLATAFORMA”,&nbsp;</strong>podendo ser
    acessada por&nbsp;<em>computadores,
      notebooks</em><strong>,&nbsp;</strong><em>smartphones</em>&nbsp;ou&nbsp;<em>tablets.</em></p>



  <p><strong>SERVIÇO ou SERVIÇOS:</strong>&nbsp;Serviços oferecidos por meio da PLATAFORMA.</p>



  <p><strong>SESSION ID</strong>: identificação da sessão do USUÁRIO no processo de inscrição ou quando
    utilizado de alguma forma na PLATAFORMA.</p>



  <p><strong>TERMOS E CONDIÇÕES DE USO DA PLATAFORMA ou TERMOS DE USO</strong>: Constituem os termos legais
    que regulamentam a relação entre a RAPPI, a PARCEIRA DO ARRANJO DO ARRANJO&nbsp; e os USUÁRIOS.</p>



  <p><strong>TRATAMENTO</strong>: é qualquer tipo de atividade baseada em Dados Pessoais, incluindo, por
    exemplo, as seguintes atividades: coleta, registro, armazenamento, organização
    consulta, uso, divulgação, compartilhamento, transmissão, classificação, reprodução,
    processamento e avaliação.</p>



  <p><strong>USUÁRIO</strong>: é a pessoa natural usuária da Plataforma RAPPI, identificada neste
    Instrumento como USUÁRIO.</p>



  <p><strong>USUÁRIO DA PLATAFORMA RAPPI</strong>: são as pessoas físicas cadastradas na Plataforma de Internet
    denominada&nbsp;<strong>RAPPI&nbsp;</strong>também
    denominados&nbsp;<strong>“USUÁRIO”</strong>,<strong>&nbsp;“USUÁRIOS”,
      “TITULAR DO DADO”ou “VOCÊ”. </strong></p>



  <p>A <strong>RAPPI</strong> e o <strong>USUÁRIO</strong> poderão ser mencionados
    individualmente neste Instrumento como “Parte” ou em conjunto como “Partes”.</p>



  <p><strong>2.Obtenção dos dados e informações:</strong></p>



  <p>Os dados e informações (sejam eles PESSOAIS ou ANÔNIMIZADOS) serão
    obtidos quando o USUÁRIO: (a) Passar a utilizar os SERVIÇOS da PLATAFORMA; (b)
    Interagir com as diversas ferramentas existentes na PLATAFORMA, fornecendo as
    informações voluntariamente ou involuntariamente (no caso de obtenção de
    informações sobre a frequência de utilização da PLATAFORMA ou os tipos de
    informações envolvidas; ou (c) Entrar em contato por meio dos canais de
    comunicação disponíveis na PLATAFORMA.</p>



  <p><strong>3.Armazenamento dos Dados e Informações</strong>:</p>



  <p>Todas as MENSAGENS DE DADOS e informações coletadas dos USUÁRIOS serão
    incorporados ao BANCO DE DADOS da PLATAFORMA, sendo seus responsáveis e
    proprietários a RAPPI e a PARCEIRA DO ARRANJO. Os dados e informações coletados
    estarão armazenados em ambiente seguro, observado o estado da técnica
    disponível e criptografados, e somente poderão ser acessados por pessoas
    qualificadas e autorizadas pela RAPPI e/ou pela PARCEIRA DO ARRANJO.
    Considerando que nenhum sistema de segurança é absolutamente seguro, a RAPPI e
    a PARCEIRA DO ARRANJO DO ARRANJO se eximem de quaisquer responsabilidades por
    eventuais danos e/ou prejuízos decorrentes de falhas, vírus ou invasões do
    BANCO DE DADOS na PLATAFORMA. </p>



  <p>Nós manteremos
    seus Dados Pessoais somente pelo tempo que for necessário para cumprir com as
    finalidades para as quais os coletamos, inclusive para fins de cumprimento de
    quaisquer obrigações legais, contratuais, de prestação de contas ou requisição
    de autoridades competentes.</p>



  <p>Para determinar
    o período de retenção adequado para cada tipo de Dado Pessoal tratado pela
    Rappi, sempre consideramos a quantidade, a natureza e a sensibilidade de tais
    Dados, o risco potencial de danos decorrentes do seu uso não autorizado ou da
    sua divulgação, a finalidade do tratamento e se podemos alcançar tais
    propósitos por outros meios, e os requisitos legais aplicáveis.</p>



  <p><strong>4.Uso dos Dados e Informações:</strong></p>



  <p>Com exceção do disposto abaixo, a RAPPI e a PARCEIRA DO ARRANJO DO
    ARRANJO não alugam, não vendem e não compartilham as informações pessoais com
    outras pessoas ou com empresas não afiliadas, exceto com o objetivo de fornecer
    ao USUÁRIO os produtos e serviços solicitados na PLATAFORMA, tendo obtido para
    tanto a sua permissão, ou em circunstâncias específicas, como ordem judicial ou
    advindas de lei.</p>



  <p>Poderão ser solicitados dos USUÁRIOS do <strong>ARRANJO DE PAGAMENTO VISA</strong>, dentre outros, os seguintes
    dados: CPF/CNPJ,
    nome completo, data de nascimento, endereço residencial, endereço de e-mail,
    nome completo da mãe e número de telefone, cópia de documento de identidade ou
    de Carteira Nacional de Habilitação, “selfie”, autodeclaração de Pessoa Exposta
    Politicamente (se aplicável), IP, hora e data de acesso, geolocalização, dados
    sobre o dispositivo de acesso e cookies, perfil e comportamento de compra,
    volume e número de transações e por meio da Plataforma, dados gerais de
    navegabilidade, utilização da Plataforma e funis de eventos.</p>



  <p>Ademais, o USUÁRIO aceita de maneira expressa, consciente e voluntária
    que as suas informações consignadas nas bases de dados da RAPPI (pessoais ou
    anônimizados), sejam recompiladas, armazenadas para sua utilização nos
    seguintes termos: (i) Juntar ou coletar os dados pessoais e incorporá-los e
    armazená-los em nossa base de dados, (ii) Organizar, catalogar, classificar,
    dividir ou separar a informação entregue, (iii) Utilizar os dados fornecidos em
    campanhas de comunicação, divulgação e promoção ou oferta de produtos,
    atividades ou serviços desenvolvidos como parte de estratégias internas da
    RAPPI, (iv) Utilizá-los para fins administrativos internos ou comerciais tais
    como: estudos de crédito, elaboração e apresentação de orçamentos, referencias
    comerciais de experiência, estudos de mercado, análises estatísticas,
    realização de pesquisas sobre satisfação, oferecimento ou reconhecimento de
    benefícios próprios do programa de fidelidade da RAPPI, bem como &nbsp;em
    serviços pós venda, (v) Conservar registros históricos dentro da RAPPI e manter
    contato com os USUÁRIOS, (vi) Verificar, comprovar ou validar os dados entregues,
    (vii) Estudar e analisar a informação fornecida para o acompanhamento e
    melhoramento dos produtos e do serviço, (viii) Entregar e transmitir a
    informação recolhida a terceiros com os que a RAPPI mantenha contratos
    comerciais ou de armazenamento e administração dos dados pessoais, sob os
    padrões de segurança e confidencialidade aos quais RAPPI está obrigada de
    acordo com o conteúdo das leis pertinentes, (ix) Transmitir dados em nível
    nacional ou internacional para fornecedores com os quais a Rappi desenvolve
    atividades em conformidade com seu objeto social. Da mesma forma, uma
    transmissão pode ser feita para os aliados/parceiros estratégicos da empresa
    para realizar atividades de marketing, publicidade e promoções associadas ao
    objeto social; Tudo isso de acordo com as disposições da legislação brasileira.
    (x)Comunicar e permitir o acesso aos dados pessoais fornecidos a terceiros
    fornecedores de serviços de apoio geral e às pessoas físicas ou jurídicas
    pertencentes ao quadro societário da&nbsp;RAPPI, (xi) Juntar, possuir, manusear
    e utilizar a informação recebida pelo USUÁRIO para realizar a vinculação como
    contratante ou fornecedor, (xiii) Juntar, possuir, manusear e utilizar a
    informação para realizar controle e prevenção de fraude, controle e prevenção de
    lavagem de ativos e financiamento do terrorismo, (xiv) Celebração, execução e
    gestão das propostas de negócios e contratos objeto dos serviços prestados,
    (xv) realizar, em conformidade com a lei, os relatórios a centrais de risco por
    não cumprimento das obrigações financeiras derivadas da relação comercial,
    (xvi) &nbsp;Fornecer informações dos USUÁRIOS em cumprimento a ordem legal ou
    judicial, (xvii) compartilhar com terceiros dos dados dos USUÁRIOS para o fim
    de recebimento de promoções ou outras informações. No caso de e-mails encaminhados
    pela RAPPI o cliente sempre terá a opção de não mais recebê-los e (xviii) . compartilhar os
    dados dos USUÁRIOS do ARRANJO DE PAGAMENTO VISA com a Visa, a PARCEIRA DO
    ARRANJO DO ARRANJO e demais terceiros previstos nesta Política de Privacidade, para
    que haja integração do USUÁRIO (e de seus adicionais, quando indicados) às plataformas
    promocionais da Visa, a fim de que o USUÁRIO tenha acesso (e seus adicionais,
    quando indicados) a descontos, ofertas e promoções disponibilizados pela Visa e
    seus parceiros. Os e-mails enviados pela RAPPI não contêm anexos para serem baixados e
    tampouco solicitam dados dos USUÁRIOS. Assim, os dados dos cartões de crédito
    somente serão solicitados no momento de realizar o pagamento virtual, e não
    serão armazenados pela RAPPI.</p>



  <p><strong>5.Do Registro de Atividades:</strong></p>



  <p>A quantidade e o tipo de Dados
    Pessoais coletados pela Rappi variam conforme o seu uso da Plataforma.
    Coletaremos diferentes Dados caso você seja um Consumidor utilizando a
    Plataforma, um Mandatário ou um representante de um dos nossos Estabelecimentos
    Parceiros. </p>



  <p>Para esclarecer essas
    questões, listamos abaixo algumas finalidades para as quais seus Dados podem
    ser utilizados, dependendo da sua forma de utilização da Plataforma, para que
    você possa entender o que se aplica especificamente a você:</p>



  <ul>
    <li><strong>Consumidores</strong>: Caso você use a
      Plataforma como um Consumidor, isto é, um Usuário que envia Encargos para que a
      Rappi possa conectá-lo a um Mandatário para que este possa, por sua vez,
      atender ao seu pedido e realizar o seu Encargo, poderemos coletar Dados a
      partir da sua utilização da Plataforma e do seu cadastro, conforme detalhado a
      seguir:</li>
  </ul>



  <figure class="wp-block-table">
    <table class="">
      <tbody>
        <tr>
          <td>
            <strong><em>Origem</em></strong><strong></strong>
          </td>
          <td>
            <strong>Tipo de Dados Coletados</strong>
          </td>
          <td>
            <strong>Finalidade</strong>
          </td>
          <td>
            <strong>Bases
              Legais</strong>
          </td>
        </tr>
        <tr>
          <td>
            <strong><em>Cadastro
                na Plataforma</em></strong><strong></strong>
          </td>
          <td>
            <strong>Dados
              de cadastro</strong>: nome, e‑mail, telefone, endereço de entrega, CPF,
            número do cartão para pagamento (quando este é o método de pagamento) e,
            quando for solicitado um Cartão, CNH, data de nascimento, endereço
            residencial, nome da mãe, foto e autodeclaração de Pessoa Exposta
            Politicamente.
          </td>
          <td>
            Cadastro
            na Plataforma, solicitação e entrega de pedidos, realização de operações de
            pagamento, envio de comprovantes de pedidos, envio de brindes, contatos
            telefônicos (ligação, SMS, push e WhatsApp)e emissão do Cartão.
            &nbsp;
            Análise
            do perfil de consumo, perfilhamento para fins de inteligência de mercado e
            envio de publicidade própria e de terceiros.
          </td>
          <td>
            Consentimento,
            Execução de Contrato e
            Legítimo
            Interesse
          </td>
        </tr>
        <tr>
          <td>
            <strong><em>Interação
                com a Plataforma</em></strong><strong></strong>
          </td>
          <td>
            <strong>Dados de navegação</strong>: endereço do IP, IMEI do dispositivo do Usuário, dados locacionais e
            comportamento de consumo na Plataforma para análise de preferências.
            &nbsp;
            <strong>Dados sobre o dispositivo de acesso</strong>: endereço do IP, IMEI do dispositivo do usuário e dados
            locacionais.
          </td>
        </tr>
      </tbody>
    </table>
  </figure>



  <ul>
    <li><strong>Mandatários</strong>: Caso você use a
      Plataforma como um Mandatário, isto é, um Usuário que realiza Encargos para
      atender às solicitações de Consumidores, poderemos coletar Dados a partir da
      sua utilização da Plataforma e do seu cadastro, conforme detalhado a seguir:</li>
  </ul>



  <figure class="wp-block-table">
    <table class="">
      <tbody>
        <tr>
          <td>
            <strong><em>Origem</em></strong><strong></strong>
          </td>
          <td>
            <strong>Tipo de Dados Coletados</strong>
          </td>
          <td>
            <strong>Finalidade</strong>
          </td>
          <td>
            <strong>Bases Legais</strong>
          </td>
        </tr>
        <tr>
          <td>
            <strong><em>Cadastro
                na Plataforma</em></strong><strong></strong>
          </td>
          <td>
            <strong>Dados
              de cadastro</strong>: nome, e‑mail, RG, CPF, CNH, placa da moto (quando
            aplicável) e endereço residencial
          </td>
          <td>
            Cadastro
            na Plataforma, solicitação e entrega de pedidos, realização de operações de
            pagamento, contatos telefônicos (ligação, SMS, push e WhatsApp), envio de
            comprovantes de pedidos e envio de brindes.
            &nbsp;
            Análise
            do perfil do Mandatário, verificação do cumprimento dos Encargos e envio de
            publicidade.
          </td>
          <td>
            Consentimento,
            Execução de Contrato e
            Legítimo
            Interesse
          </td>
        </tr>
        <tr>
          <td>
            <strong><em>Interação
                com a Plataforma</em></strong><strong></strong>
          </td>
          <td>
            <strong>Dados sobre o dispositivo de acesso</strong>: endereço do IP, IMEI do dispositivo e geolocalização
            no momento da
            entrega
          </td>
        </tr>
      </tbody>
    </table>
  </figure>



  <ul>
    <li><strong>Representantes de Estabelecimentos Parceiros</strong>: Caso você use a
      Plataforma como um representante de um dos nossos Estabelecimentos Parceiros,
      isto é, um Usuário que recebe pedidos realizados por Consumidores para preparo
      e posterior entrega a um Mandatário designado pela Rappi, poderemos coletar
      Dados a partir da sua utilização da Plataforma e do seu cadastro, conforme
      detalhado a seguir:</li>
  </ul>



  <figure class="wp-block-table">
    <table class="">
      <tbody>
        <tr>
          <td>
            <strong><em>Origem</em></strong><strong></strong>
          </td>
          <td>
            <strong>Tipo de Dados Coletados</strong>
          </td>
          <td>
            <strong>Finalidade</strong>
          </td>
          <td>
            <strong>Bases
              Legais</strong>
          </td>
        </tr>
        <tr>
          <td>
            <strong><em>Cadastro
                na Plataforma e Formalização de Contrato</em></strong><strong></strong>
          </td>
          <td>
            <strong>Dados
              de cadastro</strong>: nome do representante legal e CPF, número de telefone
            do representante, dados bancários (banco, agência e conta corrente), endereço
            do IP e IMEI do dispositivo do responsável pela assinatura do contrato.
          </td>
          <td>
            Cadastro
            na Plataforma, cumprimento da parceria comercial e criação da loja virtual do
            Estabelecimento Parceiro na Plataforma.
          </td>
          <td>
            Consentimento
            e Execução de Contrato
          </td>
        </tr>
      </tbody>
    </table>
  </figure>



  <p>Além dos Dados Pessoais acima,
    a Plataforma poderá utilizar Cookies e tecnologias similares para customizar a
    experiência dos Usuários na Plataforma e para gerar informações relevantes
    sobre a forma de uso da Plataforma pelos Usuários para a Rappi. Para entender
    como Cookies e tecnologias similares são utilizadas pela Rappi e para exercer
    seus direitos de escolha quanto ao uso de referidas tecnologias na Plataforma,
    por favor verifique a nossa <a href="https://legal.rappi.com/brazil/politica-de-cookies-brasil/">Política de
      Cookies</a>.</p>



  <p>Os registros mencionados poderão ser utilizados pela RAPPI em casos de
    investigação de fraudes ou de alterações indevidas em seus sistemas e
    cadastros, assim como no compartilhamento com terceiros de forma ANÔNIMIZADA.</p>



  <p><strong>6.Cookies</strong>:</p>



  <p>A PLATAFORMA poderá fazer o uso de COOKIES, cabendo ao USUÁRIO
    configurar o seu navegador de Internet, caso deseje bloqueá-los. Nesta
    hipótese, algumas funcionalidades da PLATAFORMA poderão ser limitadas. O
    USUÁRIO autoriza expressamente, no momento da aceitação desta Política de
    Privacidade, o uso de COOKIES pela RAPPI em toda atividade de uso que for
    realizada na PLATAFORMA.</p>



  <p><strong>7.Direitos do USUÁRIO:</strong></p>



  <p>Seus Dados Pessoais são seus e
    a legislação brasileira lhe garante, na sua condição de Titular de Dados
    Pessoais, uma série de direitos relacionados aos seus Dados. Nós estamos
    comprometidos com o cumprimento desses direitos e, nessa seção, explicaremos
    quais são esses direitos e como você pode exercê-los junto à Rappi. </p>



  <ul>
    <li><strong>Confirmação de existência
        de tratamento</strong>:
      Você pode solicitar a nossa confirmação acerca da existência ou inexistência de
      atividades de tratamento dos seus Dados Pessoais.</li>
  </ul>



  <ul>
    <li><strong>Acesso aos seus Dados
        Pessoais</strong>:
      Você pode requisitar e receber uma cópia dos seus Dados Pessoais que nós
      possuímos sobre você.</li>
  </ul>



  <ul>
    <li><strong>Retificação dos seus Dados
        Pessoais: </strong>Você
      pode solicitar a correção e/ou retificação dos seus Dados Pessoais, caso você
      identifique que alguns deles estão incorretos. Contudo, para ser efetivada essa
      correção, possivelmente precisaremos checar a validade dos Dados que você nos
      fornecerá.</li>
  </ul>



  <ul>
    <li><strong>Eliminação dos seus Dados
        Pessoais: </strong>Você
      pode solicitar a exclusão dos seus Dados Pessoais das bases de dados que
      utilizamos para trata-los. Todos os Dados coletados serão excluídos de nossos servidores
      quando você assim requisitar ou quando estes não forem mais necessários ou
      relevantes para lhe oferecermos os nossos serviços, salvo se houver qualquer
      outra razão para a sua manutenção, como eventual obrigação legal de retenção de
      Dados ou necessidade de preservação destes para resguardar direitos da Rappi.</li>
  </ul>



  <ul>
    <li><strong>Objeção ao tratamento de
        Dados Pessoais</strong>:Você pode contestar a nossa forma de tratamento dos seus Dados Pessoais
      para determinadas finalidades. Em certas situações, podemos demonstrar que
      temos motivos legítimos para tratar seus Dados, os quais podem eventualmente se
      sobrepor aos seus direitos, caso, por exemplo, sejam estritamente essenciais
      para a funcionalidade de determinado aspecto da Plataforma.</li>
  </ul>



  <ul>
    <li><strong>Portabilidade dos seus Dados
        Pessoais</strong>:
      Você pode solicitar o fornecimento direto a você (ou a terceiros que você
      escolher) dos seus Dados Pessoais em formato estruturado e interoperável.</li>
  </ul>



  <ul>
    <li><strong>Revogação do consentimento:
      </strong>Nashipóteses em que
      você tiver fornecido o seu consentimento para que pudéssemos realizar
      atividades de tratamento específicas com seus Dados Pessoais, você pode retirar
      o seu consentimento. Isso não afetará a legalidade de qualquer atividade
      realizada anteriormente à sua retirada de consentimento. Além disso, se você
      retirar o seu consentimento, talvez não possamos fornecer determinados
      produtos, serviços, benefícios ou vantagens. Caso isso possa ocorrer,
      forneceremos informações específicas a você para ajudar na sua tomada de
      decisão.</li>
  </ul>



  <ul>
    <li><strong>Revisão de decisões
        automatizadas: </strong>Você
      pode solicitar a revisão de decisões tomadas unicamente com base no tratamento
      automatizado de seus Dados Pessoais que afetem seus interesses.</li>
  </ul>



  <p>Em alguns casos, você terá a
    opção de não fornecer certos Dados Pessoais e/ou de não permitir certas formas
    de tratamento (ao não fornecer o seu consentimento para uma finalidade
    específica, por exemplo). Nesses casos, é importante ter em mente que alguns
    Dados e/ou algumas autorizações específicas que dependem do seu consentimento
    podem ser condição para que você possa usufruir de alguns de nossos produtos,
    serviços, benefícios e facilidades. Sempre que esse for o caso e o tratamento
    dos seus Dados for condição para determinada finalidade, você será informado
    antes que possa tomar uma decisão sobre isso.</p>



  <p>Para apresentar uma requisição
    de exercício de qualquer dos direitos acima, você pode optar pelo uso dos meios
    descritos abaixo: </p>



  <p><strong>Atendimento Eletrônico:</strong>&nbsp;um requerimento deve ser apresentado por meio do envio de uma
    mensagem de e-mail para servicioaocliente&#64;rappi.com.</p>



  <p><strong>Atendimento Escrito:</strong>&nbsp;um requerimento deve ser apresentado por meio do envio de uma
    solicitação escrita endereçada à Rappi, no endereço: Rua Dr. Renato Paes de
    Barros, 33, São Paulo, SP, Brasil, sendo necessária a indicação do endereço
    escolhido para o posterior recebimento de notificações e respostas da Rappi.</p>



  <p><strong>Atendimento Pessoal:</strong>&nbsp;um requerimento deve ser apresentado pessoalmente no endereço: Rua
    Dr. Renato Paes de Barros, 33, São Paulo, SP, Brasil.</p>



  <p>Em qualquer dos casos, para a
    sua segurança e, para que possamos validar a sua identidade e confirmar que
    você está solicitando Dados Pessoais sobre os quais você efetivamente detém
    direitos, precisaremos submeter a sua requisição a um processo de validação
    interna de identidade. Durante esse processo, solicitaremos o cumprimento dos
    seguintes requisitos:</p>



  <ul>
    <li>Você
      deverá ser o Titular dos Dados sobre os quais você faça algum requerimento,
      provando sua identidade mediante a apresentação de evidências que provem a sua
      identidade de forma suficiente, de acordo com o critério exclusivo da Rappi;</li>
    <li>Caso
      você seja um sucessor legítimo de um Usuário na forma da lei, os requisitos do
      item ‘<strong>1</strong>’ acima deverão ser aplicáveis não somente ao Usuário, mas também
      a você e à sua condição de sucessor legítimo do Usuário; e</li>
    <li>Caso
      você seja um representante ou procurador de um Usuário, os requisitos do item ‘<strong>1</strong>’
      acima deverão ser aplicáveis não somente ao Usuário, mas também a você e à sua
      condição de representante ou procurador do Usuário. Estes requisitos também se
      aplicam a representantes legais de crianças, adolescentes e incapazes.</li>
  </ul>



  <p><strong>8.Forma de conhecer a informação do USUÁRIO e como exercer os direitos:</strong></p>



  <p>A Rappi apresenta á escolha do Usuário as seguintes formas de exercer
    seus direitos de “Dados Pessoais”:<br>
    <br>
  </p>



  <p><strong>Atendimento eletrônico:</strong>&nbsp;O Usuário do dado deverá realizar seu requerimento formal ao
    endereço eletrônico servicioaocliente&#64;rappi.com prévio esgotamento dos
    requisitos de legitimação para o exercício do Usuário, a saber:</p>



  <p>I. Ser titular da informação, provar sua identidade em forma suficiente
    mediante qualquer meio que Rappi destine para tanto.</p>



  <p>II. Pelos legítimos sucessores, os quais deverão provar tal qualidade.</p>



  <p>III. Pelo representante/empoderado do titular da informação, quem também
    deverá provar tal qualidade.</p>



  <p>IV. Por acordo em favor de outro ou por outro exercerão por conjunto das
    pessoas que estejam possibilitadas para representá-los, e igualmente se deverá
    provar tal qualidade.</p>



  <p>V. Os direitos dos menores de idade se exercerão pelas pessoas
    encarregadas de sua representação, e igualmente se deverá provar tal qualidade.</p>



  <p><strong>Atendimento escrito:</strong>&nbsp;O Usuário do dado deverá realizar seu requerimento formal ao
    endereço: Rua Dr Renato Paes de Barros, 33, São Paulo, SP, Brasil, prévio
    esgotamento dos requisitos de legitimação para o exercício do Usuário, segundo
    o descrito de forma literal no a do presente parágrafo anterior, mediante
    escrito onde se especifique o endereço onde receberá notificações e respostas.</p>



  <p><strong>Atendimento pessoal:</strong>&nbsp;O Usuário do dado deverá realizar seu requerimento verbal no
    endereço: Rua Dr Renato Paes de Barros, 33, São Paulo, SP, Brasil, prévio
    esgotamento dos requisitos de legitimação para o exercício do Usuário, segundo
    o descrito de forma literal a do presente parágrafo.</p>



  <p><strong>9.Violação da base de dados ou sistema</strong></p>



  <p>Não é permitida a utilização de nenhum dispositivo, software, ou outro
    recurso que venha a interferir nas atividades e operações do RAPPI e/ou da PARCEIRA
    DO ARRANJO, bem como nas publicações de Oferta, descrições, contas ou seus
    bancos de dados. Qualquer intromissão, tentativa de, ou atividade que viole ou
    contrarie as leis de direito de propriedade intelectual e/ou as proibições
    estipuladas neste instrumento, tornarão o responsável passível das ações legais
    pertinentes, bem como das sanções aqui previstas, sendo ainda responsável pelas
    indenizações por eventuais danos causados.</p>



  <p>A entrada ou uso
    não autorizado de contas, falhas de hardware ou software e outros fatores
    alheios à vontade e ao controle razoável da Rappi podem comprometer a segurança
    dos seus Dados Pessoais a qualquer momento. Por isso, pedimos que você nos
    ajude a manter um ambiente seguro para todos. Além de manter as suas
    informações de acesso à Plataforma secretas e adotar práticas visando à
    segurança da sua conta e aos seus Dados, pedimos que caso você identifique ou
    tome conhecimento de algo que comprometa a segurança dos seus Dados, por favor
    entre em contato conosco enviando uma mensagem de e-mail para <a
      href="mailto:legal.br@rappi.com">legal.br&#64;rappi.com</a> e detalhando a situação para que possamos ajuda-lo da
    melhor forma.</p>



  <p><strong>10. Política de Proteção de Dados Pessoais </strong></p>



  <p>A Rappi sempre
    planeja e toma medidas técnicas, administrativas e organizacionais para proteger
    todos os Dados Pessoais que trata contra perdas, usos não autorizados ou outras
    situações ilícitas ou acidentais de tratamento indevido. Todos os Dados
    Pessoais tratados pela Rappi são armazenados e processados em ambientes
    operacionais seguros não acessíveis ao público.</p>



  <p>Com a finalidade
    de garantir a segurança de seus Dados Pessoais na nossa operação da Plataforma,
    adotamos as melhores práticas de segurança da informação disponíveis, incluindo
    o uso de soluções de criptografia ponto a ponto para transmitir os Dados
    Pessoais e outras informações;</p>



  <p>A entrada ou uso
    não autorizado de contas, falhas de hardware ou software e outros fatores
    alheios à vontade e ao controle razoável da Rappi podem comprometer a segurança
    dos seus Dados Pessoais a qualquer momento. Por isso, pedimos que você nos
    ajude a manter um ambiente seguro para todos. Além de manter as suas
    informações de acesso à Plataforma secretas e adotar práticas visando à
    segurança da sua conta e aos seus Dados, pedimos que caso você identifique ou
    tome conhecimento de algo que comprometa a segurança dos seus Dados, por favor
    entre em contato conosco enviando uma mensagem de e-mail para legal.br&#64;rappi.com
    e detalhando a situação para que possamos ajuda-lo da melhor forma.</p>



  <p><strong>11. Das Disposições Gerais:</strong></p>



  <p>Como estamos
    sempre buscando melhorar a Plataforma e os nossos serviços, essa Política de
    Privacidade pode passar por atualizações. Desta forma, recomendamos que você
    visite periodicamente esta página para que tenha conhecimento sobre todas as modificações
    que faremos. Caso sejam feitas alterações relevantes, como aquelas que se
    refiram à necessidade de se obter um novo consentimento seu, publicaremos essa
    atualização e solicitaremos novo consentimento a você. </p>



  <p>As disposições constantes desta Política de Privacidade poderão ser
    atualizadas ou modificadas a qualquer momento, cabendo ao USUÁRIO verificá-las
    sempre que efetuar o acesso à PLATAFORMA.</p>



  <p><strong>12.Lei Aplicável e Jurisdição:</strong></p>



  <p>A presente Política de Privacidade será interpretada segundo a legislação
    brasileira, no idioma português, sendo eleito o Foro da Comarca de São Paulo
    para dirimir qualquer litígio, questão ou dúvida superveniente, com expressa
    renúncia de qualquer outro, por mais privilegiado que seja.</p>



  <p><strong>13. ACEITAÇÃO TOTAL DOS TERMOS</strong></p>



  <p>O USUÁRIO declara ter a capacidade legal, dando o seu CONSENTIMENTO
    expresso dos termos constantes desta Política de Privacidade, sendo que aceita
    a totalidade das situações reguladas neste documento</p>
</div><!-- .entry-content -->
